import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { TOS } from "./components/TOS";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/tos" element={<TOS />} />
      </Routes>
    </Router>
  );
}

export default App;
